import { faPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faUpload } from '@fortawesome/pro-regular-svg-icons/faUpload';
import { Tablet } from '@maxpreps/shared/corecomponents/ScreenSize/ScreenSize';
import { IConfigurableLink } from '@maxpreps/shared/models/configurableLink';
import THEME from '@maxpreps/shared/styles/colors';
import DropdownButton from '@maxpreps/shared/ui/Button/DropdownButton';
import { StyledIconButton } from '@maxpreps/shared/ui/Button/IconButton';
import Icon from '@maxpreps/shared/ui/Icon/Icon';
import OverflowMenu from '@maxpreps/shared/ui/OverflowMenu/OverflowMenu';
import React from 'react';
import styled from 'styled-components';
import TeamSmartAnchor from './TeamSmartAnchor';

const StyledScheduleOverflowMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > a {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    padding: 8px;

    svg {
      margin-right: 4px;
    }
  }

  // Give all actions the same hover effect
  > a,
  ${StyledIconButton} {
    border-radius: 8px;
    &:hover {
      background-color: ${THEME.surface.tertiary};
    }
  }

  ${StyledIconButton} {
    padding: 16px;
  }
`;

interface TeamOverflowMenuWrapperProps {
  printHref?: string;
  uploadHref?: string;
  seasonPickerItems?: IConfigurableLink[];
  menuItems?: IConfigurableLink[];
  seasonPickerText?: string;
}

const TeamHeaderActions: React.FC<TeamOverflowMenuWrapperProps> = ({
  printHref,
  uploadHref,
  seasonPickerItems,
  seasonPickerText,
  menuItems
}) => (
  <StyledScheduleOverflowMenuWrapper>
    {printHref && (
      <TeamSmartAnchor href={printHref} target="_blank">
        <Icon icon={faPrint} color={THEME.text.disabled} />
        <Tablet andAbove>Print</Tablet>
      </TeamSmartAnchor>
    )}
    {uploadHref && (
      <TeamSmartAnchor href={uploadHref}>
        <Icon icon={faUpload} color={THEME.text.disabled} />
        <Tablet andAbove>Upload</Tablet>
      </TeamSmartAnchor>
    )}
    {seasonPickerText && (seasonPickerItems?.length ?? 0) > 0 && (
      <OverflowMenu
        menuItems={seasonPickerItems as IConfigurableLink[]}
        isIntrinsiclyPositioned={false}
      >
        <DropdownButton text={seasonPickerText} as="div" />
      </OverflowMenu>
    )}
    {menuItems && <OverflowMenu menuItems={menuItems} />}
  </StyledScheduleOverflowMenuWrapper>
);

export default TeamHeaderActions;
